import React from "react";
import customerInfo from "../assets/customerInfo.jpeg";
import { showBannerAtom } from "../App";
import { useAtom } from "jotai";

const Banner = () => {
    const [showBanner] = useAtom(showBannerAtom);
    
  return (
  
        <div style={{ backgroundImage: `url(${customerInfo})` }}
          className={`h-[45vh] w-full bg-cover bg-no-repeat  bg-center my-8  flex-col justify-center items-center ${!showBanner?'hidden lg:flex':'flex'}`}>
          <div className="AppInner sm:text-left flex flex-col items-center md:items-start space-y-6 p-2">
            <h1 className="text-3xl md:text-5xl font-bold drop-shadow-7xl px-4 text-[#dd4f05]">
              UPDATE GHANA
              <br /> CARD INFORMATION
            </h1>

            {/* <button className="bg-[#dd4f05] text-white px-3 py-2 w-40">Link Your Card</button> */}
          </div>
        </div>
     
  );
};

export default Banner;
